

const SAFE_GLOBALS = {
  Function,
  isFinite,
  isNaN,
  parseFloat,
  parseInt,
  decodeURI,
  decodeURIComponent,
  encodeURI,
  encodeURIComponent,
  atob,
  btoa,
  URLSearchParams,
  FormData,
  Boolean,
  Number,
  BigInt,
  Blob,
  String,
  Object,
  Array,
  AbortController,
  Symbol,
  Error,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Map,
  Set,
  WeakMap,
  WeakSet,
  Promise,
  Intl,
  JSON,
  Math,
  Date,
  RegExp
};

const DEFAULT_CONST_AND_MACROS = {
  constants: {
    SCRIPTING_RUNTIME_REV: 115,
    M_PI: 3.14159265358979323846,
    MAX_INT: Number.MAX_SAFE_INTEGER,
    MIN_INT: Number.MIN_SAFE_INTEGER
  },
  macros: {
    DEG_TO_RAD: "(x) (x*Math.PI/180)",
    RAD_TO_DEG: "(x) (x*180/Math.PI)",
    ASSERT: "(x) if((x) == false) { throw new Error('Assertion failed: ' + '(x)'); }"
  }
};

export { DEFAULT_CONST_AND_MACROS, SAFE_GLOBALS };
